import { HTTPError } from '@funtech-int/web-toolkit';

export class MovieNotFoundError extends HTTPError {
    constructor(url: string) {
        super(404, 'Movie not found', url);
    }
}
